import * as urls from "./url";
import client, { getHeader } from "../client";
import { interceptor } from "../../util/util";

//admin-service
export const getNotificationBannnerCall = async () => interceptor(async () => client.get(urls.getNotificationBannner(), getHeader()));
export const getPlannedMaintenanceCall = async () => interceptor(async () => client.get(urls.getPlannedMaintenance(), getHeader()));
